import "bootstrap/dist/css/bootstrap.min.css"
import CenteredPaperListPage from "./paperList"

export default function App() {
  return (
    <div className="App">
      <header className="App-header">
        <CenteredPaperListPage />
      </header>
    </div>
  )
}
